import React, {useEffect, useState} from 'react';
import styled from '@emotion/styled';
import Button from '@mui/material/Button';
import DeveloperInfo from '../../components/common/DeveloperInfo';
import {TypeAnimation} from 'react-type-animation';
import {QUESTION_TYPE_IMAGE_MAP, SOLVING_METHODS} from '../../constants/appConstants';
import { useQuestionStore } from '../../store/useQuestionStore';

const JigsawPuzzleExample3Styled = styled.div`
    align-items: center;
    text-align: center;
`;

function CommonPuzzleCurrent({questionType, settings, isVoteSubmitted, solvingMethod}) {
  const puzzleImages = QUESTION_TYPE_IMAGE_MAP[questionType]
  const [isGameStarted, setIsGameStarted] = useState(false);
  const [isSolved, setIsSolved] = useState(false);
  const [showAnswer, setShowAnswer] = useState(false);
  const questionStore = useQuestionStore()
  

  useEffect(() => {
    if (isVoteSubmitted) {
      setIsGameStarted(true)
    }
    setIsSolved(isVoteSubmitted)
  }, [isVoteSubmitted]);

  useEffect(() => {
    setShowAnswer(solvingMethod === SOLVING_METHODS.MANUALLY)
  }, [solvingMethod]);

  const renderImage = ({src = puzzleImages.SOLVED}) => {
    return <div
      style={{padding: 20}}
    ><img
      alt={'Puzzle unsolved image'}
      width={'100%'}
      height={'90%'}
      // height={290}
      style={{border: '3px solid grey'}}
      src={src}/>
    </div>
  }

  const renderSolved = (isSolvedByUser) => {
    return <div>
      {renderImage({src: puzzleImages.SOLVED})}
      <div>
        {isSolvedByUser && <TypeAnimation
          sequence={[
            `Congrats! You solved the ${questionType}!!`,
            2000,
          ]}
          wrapper="span"
          speed={50}
          style={{fontSize: '1em', display: 'block'}}
          repeat={Infinity}
        />}
      </div>
    </div>
  }

  const unsolvedPuzzle = () => (<>
    {renderImage({src: puzzleImages.UNSOLVED})}
  </>)


  const developerInfo = () => {
    return <DeveloperInfo>
      <Button onClick={() => setIsSolved(!isSolved)}>Show/hide success screen </Button>
    </DeveloperInfo>
  }
  return <JigsawPuzzleExample3Styled>
    {developerInfo()}
    {isGameStarted ? <>
        {isSolved ? renderSolved(!showAnswer) : unsolvedPuzzle()}
      </>
      : <>
        <div style={{
          // position: 'relative'
        }}>
          <div style={{filter: 'blur(8px)', opacity: 0.2}}>
            {renderImage({src: puzzleImages.UNSOLVED})}
          </div>
          <Button style={{position: 'absolute', top: '40%', left: '30%'}} type={'button'}
                  variant={'contained'}
                  onClick={() => {
                    questionStore.updateStartState('0', !isGameStarted)
                    setIsGameStarted(!isGameStarted)
                    }}>
            Start {questionType}</Button>
        </div>

      </>
    }
  </JigsawPuzzleExample3Styled>
}

export default CommonPuzzleCurrent;